import { createJobDraftDetailsFormContainer } from './container'
import { JobDraftDetailsFormUI } from './ui/job-draft-details-form'

export const JobDraftDetailsFormComponent = createJobDraftDetailsFormContainer(JobDraftDetailsFormUI)
